import { useRef, useState } from 'react';

export function useHoverFetch<T = any>(url: string) {
  const [data, setData] = useState<T | null>(null);
  const [loading, setLoading] = useState(false);
  const ctrl = useRef<AbortController | null>(null);

  const onOpen = async () => {
    if (data || loading) return;
    
    ctrl.current?.abort();
    ctrl.current = new AbortController();
    setLoading(true);
    
    try {
      const res = await fetch(url, { 
        signal: ctrl.current.signal, 
        credentials: 'include' 
      });
      if (res.ok) {
        const result = await res.json();
        setData(result);
      }
    } catch (err: any) {
      if (err.name !== 'AbortError') {
        console.error('Hover fetch error:', err);
      }
    } finally {
      setLoading(false);
    }
  };

  return { data, loading, onOpen };
}
